if (!customElements.get('home-carousel')) {
    class ImageSwiper extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
         
            if (!this.hasAttribute('mobile-swiper-destory') || $(window).width() > 750) {
                let that=this;
                this.mySwiper = new Swiper(this.querySelector(`.image_carousel_container`), {
                    slidesPerView: 4,
                    observer: true,
                    spaceBetween: 20,
                    resizeObserver: true,
                    navigation: {
                        nextEl: this.querySelector(`.swiper-btn-next`),
                        prevEl: this.querySelector(`.swiper-btn-prev`),
                    },
                    pagination: {
                        el: this.querySelector(`#${this.id} .swiper-pagination`),
                        clickable: true,
                    },
                    on: {
                        slideChange: this.handleSlideChange.bind(this),
                    },
                    scrollbar: {
                        el: this.querySelector(`#${this.id} .swiper-scrollbar`),
                        draggable: true,
                    },
                    breakpoints: {
                        360: {
                            spaceBetween: 15,
                        },
                        750: {
                            spaceBetween: '2.8%',
                        },
                        769: {
                            spaceBetween: 20,
                        },
                    },
                    on: {
                        init: function(swiper){ 
                            console.log($(swiper),"swiper");
                        // Get the first slide's image
const firstSlideImage = that.querySelector('.swiper-slide:first-child .image-href');

// Get the height of the first slide's image
const imageHeight = firstSlideImage.offsetHeight;

// Set the height of the next and previous buttons
const nextButton = that.querySelector('.swiper-btn-next');
const prevButton = that.querySelector('.swiper-btn-prev');

nextButton.style.top = `${imageHeight / 2}px`;
prevButton.style.top = `${imageHeight / 2}px`;
                        }, 
                      },
                });
            }
            this.initEvent(this.mySwiper);
        }

        /**
         * 轮播图切换事件
         */
        handleSlideChange(swiper) {

        }

        initEvent(swiper) {
            let height = $(`#${this.id} .swiper-slide:eq(0)`).find('img').eq(0).height() / 2
         
            // window.addEventListener('resize', () => {
            //     if (this.hasAttribute('mobile-swiper-destory')) {
            //         window.addEventListener('resize', () => {
            //             if ($(window).width() < 750) {
            //                 swiper.disable()
            //                 $(`#${this.id} .swiper-wrapper`).addClass('noswiper')

            //             } else {
            //                 swiper.enable()
            //                 $(`#${this.id} .swiper-wrapper`).remove('noswiper')
            //             }
            //         })
            //     }
            // })
        }
    }

    customElements.define('home-carousel', ImageSwiper);
}

